module.exports = __webpack_public_path__ + "img/装.ee4eb4f8.png";